import callApi from "helpers/callApi";

export const getNotes = async data => {
  return await callApi(`user_job_post_notes?user_job_post_id=${data}`);
};
